<div class="font-noto trans-x-hide tw-h-full" swipe="swipe" (coordinates)="swipeCoordinates($event)" [ngClass]="{'trans-xy-0': isTabActive }">
  <div class="tw-flex flex-col tw-bg-white tw-h-full" #homePageContainer="">
    <!--nav bar-->
    <div class="tw-fixed tw-top-0 tw-left-0 tw-right-0 tw-z-10 tw-flex tw-flex-row tw-items-center tw-gap-2 tw-bg-transparent tw-px-4 tw-py-4">
      <div class="tw-flex-none tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-rounded-xl tw-h-10 tw-w-10 cs-icon-menu" (click)="toggleMenu(true)">
        <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'menu'"></cs-icon>
      </div>
      <div class="tw-flex-1"></div>
      <div class="tw-flex-none tw-flex tw-items-center tw-justify-center tw-gap-2 tw-px-4 tw-rounded-full tw-h-10 tw-border-2 tw-border-white tw-bg-teal-200" *ngIf="showCashBalance" (click)="openBottomSheetForCash()">
        <cs-icon class="tw-h-6 tw-w-6" [iconName]="'cureskin_cash_coin'"></cs-icon>
        <p class="tw-font-body tw-font-bold tw-text-400 tw-pt-[2px]">
          {{totalCashBalance}}
        </p>
      </div>
      <div class="tw-flex-none tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-rounded-xl tw-h-10 tw-w-10 tw-relative" *ngIf="toolbarIcons[1].cartValue && userStatus.PAID" (click)="goToCart()">
        <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'shopping_cart'"></cs-icon>
        <span class="tw-absolute tw-top-[2px] tw-right-[18%] tw-bg-gray-800 tw-font-body tw-font-bold tw-h-[14px] tw-text-200 tw-text-red-400">{{toolbarIcons[1]?.cartValue}}</span>
      </div>
      <div class="tw-flex-none tw-relative tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-rounded-xl tw-h-10 tw-w-10" (click)="notificationClickAction()" [ngClass]='unreadNotifications ? "notify-icon-new" : ""'>
        <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'notifications'"></cs-icon>
      </div>
    </div>
    <!--loading-->
    <div class="shell tw-flex-1 tw-pt-14" *ngIf="loading">
      <div class="welcome">
        <div class="title shimmer"></div>
        <div class="desc shimmer"></div>
      </div>
      <section class="three">
        <div class="cardHolder">
          <div class="card shimmer" *ngFor="let i of [1,2,3]"></div>
        </div>
      </section>
      <section *ngFor="let i of [1,2]">
        <div class="header">
          <div class="title shimmer"></div>
          <div class="desc shimmer"></div>
        </div>
        <div class="cardHolder">
          <div class="card shimmer"></div>
          <div class="card shimmer"></div>
        </div>
      </section>
    </div>
    <div class="content tw-flex-1 tw-bg-gray-80 tw-overflow-y-auto tw-overflow-x-hidden" *ngIf="!loading">
      <div class="tw-flex tw-flex-col tw-bg-teal-200 tw-bg-repeat-x tw-bg-top tw-pt-14 tw-px-0 tw-overflow-visible tw-mb-20 tw-pb-0">
        <!--Three icons in header(Unpaid state)-->
        <div class="tw-mt-12 three-icons tw-px-4 tw-relative tw-left-0 tw-right-0 tw-mb-[-56px]">
          <div appTrackable bannerName="top_navigation_unpaid" pageName="homePage" class="tw-grid tw-grid-cols-2 tw-gap-2" *ngIf="!userStatus.PAID">
            <div class="fading-grid-pattern tw-bg-gray-50 tw-px-4 tw-py-2 tw-rounded-[15px] tw-flex-1" (click)="trackEventAndNavigateTo('HOME_FACE', '/user?tab=regimen&amp;class=FACE')">
              <img class="tw-max-h-[56px]" [src]="faceIconUrl" />
              <div class="tw-flex tw-justify-between tw-items-center tw-gap-2 fw-500 font14 tw-mt-2">
                <span class="text face tw-text-300 tw-text-gray-800" i18n="@@faceTreatment">Face Treatment</span>
                <em class="cs-icon-arrow font10 fw-700 tw-text-gray-800"></em>
              </div>
            </div>
            <div class="fading-grid-pattern tw-bg-gray-50 tw-px-4 tw-py-2 tw-rounded-[15px] tw-flex-1" (click)="trackEventAndNavigateTo('HOME_HAIR', '/user?tab=regimen&amp;class=HAIR')">
              <img class="tw-max-h-[56px]" [src]="hairIconUrl" />
              <div class="tw-flex tw-justify-between tw-items-center tw-gap-2 fw-500 font14 tw-mt-2">
                <span class="text hair tw-text-300 tw-text-gray-800" i18n="@@hairTreatment">Hair Treatment</span>
                <em class="cs-icon-arrow font10 fw-700 tw-text-gray-800"></em>
              </div>
            </div>
          </div>
          <div appTrackable bannerName="top_navigation_paid" pageName="homePage" class="tw-flex tw-flex-row tw-gap-2" *ngIf="userStatus.PAID && !isRebrandingHomeIcon">
            <div class="tw-flex-1 card tw-px-3 tw-pt-2 tw-pb-3 tw-rounded-2xl" [ngClass]="{'tw-break-all': [appConfig.Shared.Languages.ML, appConfig.Shared.Languages.KN, appConfig.Shared.Languages.TE, appConfig.Shared.Languages.TA].includes(user.get('languagePreference'))}" (click)="trackEventAndNavigateTo('HOME_INSTRUCTIONS', '/user?tab=regimen&fromHowToUse=true')">
              <img class="rounded mB10 flex-col tw-items-center" src="https://cdn.cureskin.com/app/img/home_how_to_use.png" />
              <div class="tw-font-body tw-font-bold tw-text-black tw-text-200 tw-text-center tw-tracking-0 tw-leading-none" i18n="@@howToUse"> How to use </div>
            </div>
            <div class="tw-flex-1 card tw-px-3 tw-pt-2 tw-pb-3 tw-rounded-2xl" [ngClass]="{'tw-break-all': [appConfig.Shared.Languages.ML, appConfig.Shared.Languages.KN, appConfig.Shared.Languages.TE, appConfig.Shared.Languages.TA].includes(user.get('languagePreference')), 'notify notify-new': tabUpdates.FOLLOWUP}" (click)="trackEventAndNavigateTo('HOME_NEED_CHECKUP', '/user/checkup')">
              <img class="rounded mB10" src="https://cdn.cureskin.com/app/img/home_checkup.png" />
              <div class="tw-font-body tw-font-bold tw-text-black tw-text-200 tw-text-center tw-tracking-0 tw-leading-none" i18n="@@doctorCheckup"> Doctor Checkup </div>
            </div>
            <div class="tw-flex-1 card tw-px-3 tw-pt-2 tw-pb-3 tw-rounded-2xl" [ngClass]="{'tw-break-all': [appConfig.Shared.Languages.ML, appConfig.Shared.Languages.KN, appConfig.Shared.Languages.TE, appConfig.Shared.Languages.TA].includes(user.get('languagePreference')), 'notify notify-new': tabUpdates.FOLLOWUP}" (click)="trackEventAndNavigateTo('HOWE_SHOP', '/user?tab=shop')">
              <img class="rounded mB10" src="https://cdn.cureskin.com/app/img/home_shop.gif" />
              <div class="tw-font-body tw-font-bold tw-text-black tw-text-200 tw-text-center tw-tracking-0 tw-leading-none" i18n="@@shopProducts"> Shop products </div>
            </div>
            <div class="tw-flex-1 card tw-px-3 tw-pt-2 tw-pb-3 tw-rounded-2xl" [ngClass]="{'tw-break-all': [appConfig.Shared.Languages.ML, appConfig.Shared.Languages.KN, appConfig.Shared.Languages.TE, appConfig.Shared.Languages.TA].includes(user.get('languagePreference')), 'notify notify-new': tabUpdates.FOLLOWUP}" (click)="trackEventAndNavigateTo('HOME_NEED_HELP', '/support')">
              <img class="rounded mB10" src="https://cdn.cureskin.com/app/img/home_need_help.png" />
              <div class="tw-font-body tw-font-bold tw-text-black tw-text-200 tw-text-center tw-tracking-0 tw-leading-none" i18n="@@needHelp">Need help</div>
            </div>
          </div>

          <div appTrackable bannerName="top_navigation_paid" pageName="homePage" class="tw-flex tw-flex-row tw-justify-center tw-items-stretch tw-gap-2" *ngIf="userStatus.PAID && isRebrandingHomeIcon">
            <div class="tw-flex-grow tw-h-[104px] tw-w-[76px] tw-flex tw-flex-col tw-items-center tw-px-[10px] tw-pt-2 tw-pb-3 tw-rounded-2xl card"
                 [ngClass]="{'tw-break-all tw-text-[6px]': enableNgClassCondition() }"
                 (click)="trackEventAndNavigateTo('HOME_INSTRUCTIONS', '/user?tab=regimen&fromHowToUse=true')">
              <cs-icon class="tw-mb-2 tw-h-[52px] tw-w-[52px]" [iconName]="'home_how_to_use'"></cs-icon>
              @if (isRegimenExpired) {
                <div class="tw-font-body tw-font-medium tw-text-black tw-text-200 tw-text-center tw-tracking-0 tw-leading-none" [ngClass]="{'tw-break-all tw-text-[10px]': enableNgClassCondition() }" i18n="@@getRegimen">
                  Get Regimen
                </div>
              } @else {
                <div class="tw-font-body tw-font-medium tw-text-black tw-text-200 tw-text-center tw-tracking-0 tw-leading-none" i18n="@@howToUse"
                   [ngClass]="{'tw-break-all tw-text-[10px]': enableNgClassCondition() }"
              >
                How to use
              </div>
              }
            </div>
            <div class="tw-flex-grow tw-h-[104px] tw-w-[76px] tw-flex tw-flex-col tw-items-center tw-px-[10px] tw-pt-2 tw-pb-3 tw-rounded-2xl card"
              [ngClass]="{'tw-break-all tw-text-[12px]': enableNgClassCondition(), 'notify notify-new': tabUpdates?.FOLLOWUP}"
              (click)="trackEventAndNavigateTo('HOME_NEED_CHECKUP', '/user/checkup')">
              <div class="tw-h-[52px] tw-w-[52px] tw-rounded-full tw-relative tw-mb-2">
                <cs-icon class="tw-h-[52px] tw-w-[52px] tw-relative" [iconName]="'home_doctor_checkup'"></cs-icon>
                <img *ngIf="shouldShowFollowUpDot" src="/assets/gifs/blinking-red-dot.gif" class="tw-absolute tw-top-1 tw-right-1 tw-w-[10px]" alt="red-blink-circle"/>
              </div>
              <div class="tw-font-body tw-font-medium tw-text-black tw-text-200 tw-text-center tw-tracking-0 tw-leading-none" i18n="@@doctorCheckup"> Doctor Checkup </div>
            </div>
            <div class="tw-flex-grow tw-h-[104px] tw-w-[76px] tw-flex tw-flex-col tw-items-center tw-px-[10px] tw-pt-2 tw-pb-3 tw-rounded-2xl card"
                 [ngClass]="{'tw-break-all tw-text-[12px]': enableNgClassCondition(), 'notify notify-new': tabUpdates?.FOLLOWUP}" (click)="trackEventAndNavigateTo('HOWE_SHOP', '/user?tab=shop')">
              <img class="tw-mb-2 tw-h-[52px] tw-w-[52px]" src="/assets/icons/home_shop.gif" />
              <div class="tw-font-body tw-font-medium tw-text-black tw-text-200 tw-text-center tw-tracking-0 tw-leading-none" i18n="@@shopProducts"> Shop products </div>
            </div>
            <div class="tw-flex-grow tw-h-[104px] tw-w-[76px] tw-flex tw-flex-col tw-items-center tw-px-[10px] tw-pt-2 tw-pb-3 tw-rounded-2xl card relative"
                [ngClass]="{'tw-break-all tw-text-[12px]': enableNgClassCondition(), 'notify notify-new': tabUpdates?.FOLLOWUP}" (click)="trackEventAndNavigateTo('HOME_NEED_HELP', '/support')">
              <div class="tw-relative">
                <img *ngIf="isTicketAwaitingResponse" src="/assets/gifs/blinking-red-dot.gif" alt="red-blink-circle" class="tw-w-[10px] tw-h-[10px] tw-aspect-square tw-absolute tw-top-2 tw-right-1 -tw-translate-y-1/3 tw-translate-x-1/3" />
                <cs-icon class="tw-mb-2 tw-h-[52px] tw-w-[52px]" [iconName]="'home_help'"></cs-icon>
              </div>
              <div class="tw-font-body tw-font-medium tw-text-black tw-text-200 tw-text-center tw-tracking-0 tw-leading-none" i18n="@@needHelp">Need help</div>
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="shouldShowGamificationRewardBanner && rewardData">
        <app-gamification-reward-banner [rewardData]="rewardData" [isClaimed]="isRewardClaimed()" (openScratchCard)="onOpenScratchCard()"></app-gamification-reward-banner>
      </ng-container>
      <ng-container *ngIf="showScratchCard && rewardData">
        <app-gamification-scratch-card
          [rewardData]="rewardData"
          [show]="showScratchCard"
          (closed)="onScratchCardClosed()"
          (rewardClaimed)="onRewardClaimed($event)">
        </app-gamification-scratch-card>
      </ng-container>
      <swiper #swiperCardsBanner="" [config]="carouselConfig">
        <ng-container *ngFor="let regimen of regimens; let i = index">
          <ng-container *ngIf="regimen.isPreparationTimePending">
            <div *swiperSlide>
              <regimen-preparation-banner [regimenClass]="regimen.class"></regimen-preparation-banner>
            </div>
          </ng-container>
        </ng-container>
      </swiper>
      @if (submitDefualtAnswersBannerItems?.length === 1) {
        <app-submit-defualt-answers-banner
          [consultation]="submitDefualtAnswersBannerItems[0].consultation"
          [thumbnailUrl]="submitDefualtAnswersBannerItems[0].thumbnailUrl"
        ></app-submit-defualt-answers-banner>
      } @else if (submitDefualtAnswersBannerItems?.length > 1) {
        <div class="tw-relative tw-mb-5">
          <swiper id="submit-default-answers-swiper" class="submit-defualt-answers-swiper tw-max-w-full" [config]="submitDefaultAnswersCarouselConfig">
            @for (item of submitDefualtAnswersBannerItems; track item.consultation) {
              <div *swiperSlide>
                <app-submit-defualt-answers-banner
                  [consultation]="item.consultation"
                  [thumbnailUrl]="item.thumbnailUrl"
                ></app-submit-defualt-answers-banner>
              </div>
            }
          </swiper>
          <div id="submit-default-answers-swiper-pagination"></div>
        </div>
      }
      <div class="tw-relative ">
        <swiper [config]="carouselConfig" #swiperProductTransitCards [ngClass]="{'tw-mb-2': swiperProductTransitCards?.swiperRef?.slides?.length > 1}" id="order-banner-swiper" class="tw-max-w-full tw-overflow-visible">
          <ng-container *ngFor="let order of allActiveOrders">
            <ng-container *ngIf="order.get('stage') === appConfig.Shared.Order.Stage.DELIVERED && order.get('showOrderDeliveredBanner')">
              <order-delivered appTrackable pageName="homePage" bannerName="order_status" [eventData]="orderStatusEventData" [carousel]="true" *swiperSlide [isRebrandingBanner]="isRebrandingBanner" [order]="order" (addEvents)="addEvents()" [orderStatusBannerExp]="orderStatusBannerExp"></order-delivered>
            </ng-container>
            <ng-container *ngIf="appConfig.Shared.Order.Stage.orderOutForDeliveryStages.includes(order?.get('stage'))">
              <out-for-delivery appTrackable pageName="homePage" bannerName="order_status" [eventData]="orderStatusEventData" [carousel]="true" *swiperSlide [isRebrandingBanner]="isRebrandingBanner" [order]="order" (addEvents)="addEvents()"></out-for-delivery>
            </ng-container>
            <ng-container *ngIf="appConfig.Shared.Order.Stage.orderDispatchedStages.includes(order?.get('stage'))">
              <order-shipped appTrackable pageName="homePage" bannerName="order_status" [eventData]="orderStatusEventData" [carousel]="true" *swiperSlide [isRebrandingBanner]="isRebrandingBanner" [order]="order" (addEvents)="addEvents()"></order-shipped>
            </ng-container>
            <ng-container *ngIf="appConfig.Shared.Order.Stage.orderPlacedStages.includes(order?.get('stage'))">
              <order-received appTrackable pageName="homePage" bannerName="order_status" [eventData]="orderStatusEventData" [carousel]="true" *swiperSlide [isRebrandingBanner]="isRebrandingBanner" [order]="order" (addEvents)="addEvents()"></order-received>
            </ng-container>
            <ng-container *ngIf="appConfig.Shared.Order.Stage.orderPackedStages.includes(order?.get('stage'))">
              <packing-order appTrackable pageName="homePage" bannerName="order_status" [eventData]="orderStatusEventData" [carousel]="true" *swiperSlide [isRebrandingBanner]="isRebrandingBanner" [order]="order" (addEvents)="addEvents()"></packing-order>
            </ng-container>
          </ng-container>
          <!--reply in ticket banner-->
          <ng-container *ngIf="replyInTicket">
            <doctor-reply appTrackable pageName="homePage" bannerName="doctor_reply" [carousel]="true" *swiperSlide [isRebrandingBanner]="isRebrandingBanner" [userDoctor]="userDoctor" (viewTicket)="viewTicket()"></doctor-reply>
          </ng-container>
        </swiper>
        <div class="tw-absolute tw-text-center tw-bottom-[-10px]" id="swiper-pagination"></div>
      </div>
      <!-- Gamification Banner Position: 2Days (After all order status banners, Above cart) -->
      <ng-container *ngIf="shouldShowMainGamificationBannerAtPosition('2Days')">
        <app-gamification-banner
          [todayProductUsageData]="todayProductUsageData"
          [user]="user"
          [regimen]="latestActiveRegimen"
          (scratchCardDismissedWithoutClaim)="onScratchCardDismissedWithoutClaim()"
          (rewardClaimed)="onRewardClaimed($event)">
        </app-gamification-banner>
      </ng-container>
      <!--      Nutra banners  -->
      <ng-container>
        <swiper *ngIf="nutraBannerExperiment && showNutraBanner && (user?.get('orderState') === appConfig.Shared.User.OrderState.DELIVERED)" appTrackable pageName="homePage" bannerName="nutra_repeat" [config]="carouselConfig" class="tw-max-w-full tw-overflow-visible tw-mb-4"
                [ngClass]="{'tw-mb-8': nutraBannerData?.length > 1}">
          <ng-container *ngFor="let eachBanner of nutraBannerData">
            <div *swiperSlide class="tw-px-4">
              <div class="tw-w-full tw-aspect-[41/24] tw-bg-cover tw-bg-right-bottom tw-bg-no-repeat tw-rounded-3 tw-overflow-hidden tw-px-6 tw-py-[26px]"
                   [style.background-image]="'url(' + eachBanner?.bannerImage + ')'"
                   (click)="openVariantsPopup(eachBanner?.margId)">
                <div class="tw-w-1/2 tw-font-body">
                  <h1 class="tw-text-700 tw-font-[700] tw-leading-6 tw-mb-1 tw-font-lexend" i18n="@@runningLow">Running Low?</h1>
                  <p class="tw-text-200 tw-font-medium tw-leading-[1.2] tw-mb-4" i18n="@@stayOnTrack">Stay on track <br/> with your results.</p>
                  <div
                    class="tw-bg-teal-600 tw-text-white tw-text-300 tw-font-[700] tw-relative shine-button tw-overflow-hidden tw-py-2 tw-rounded-3 tw-text-center tw-w-max tw-px-4"
                    i18n="@@reorderNow">Reorder Now</div>
                </div>
              </div>
            </div>
          </ng-container>
        </swiper>
      </ng-container>
      <section appTrackable pageName="homePage" [bannerName]="'aov'" class="banners bogoSale tw-mx-4 bdr-rad-15" *ngIf="user?.get('orderState') === appConfig.Shared.User.OrderState.DELIVERED && isAovSaleLive" (click)="openAovBanner()">
        <img [src]="aovBannerImage" />
      </section>
      <section appTrackable pageName="homePage" [bannerName]="'bogo'" class="banners bogoSale" *ngIf="userStatus.PAID && isBOGOSaleLive" (click)="openBogoBanner()">
        <img [src]="saleBannerImage" />
      </section>
      <section appTrackable pageName="homePage" [bannerName]="'sale_offer'" class="banners bogoSale" *ngIf="userStatus.PAID && isSaleLive" (click)="openSaleBanner()">
        <img [src]="bannerImage" />
      </section>
      <div *ngIf="(productsInCart?.length || recommendedItems?.length)" class="tw-w-full tw-px-4 tw-pt-4 tw-items-center tw-hidden">
        <div class="tw-text-200 tw-font-body tw-text-gray-800 tw-leading-[15px] tw-tracking-[2.04px] tw-uppercase tw-mr-4">Pending orders</div>
        <div class="tw-flex-grow tw-h-px tw-bg-gray-300"></div>
      </div>
      <div class="tw-relative levelFourBanners" *ngIf="(productsInCart?.length || recommendedItems?.length)">
        <ng-container *ngIf="voiceNoteByScript && userStatus.PAID">
          <app-voice-note-banner-script appTrackable pageName="homePage" [bannerName]="'voice_note_script'" (goToCart)="goToCart()" [userDrImage]="userDrImage" [productsInCart]="productAddedByScript" (emitTrackEvent)="trackEventOne($event)" [user]="user"></app-voice-note-banner-script>
        </ng-container>
        <ng-container *ngIf="productsInCart.length > 1 && userStatus.PAID && !voiceNoteByScript && !showSuggestedForYouBanner">
          <app-complete-your-multiple-order
            appTrackable pageName="homePage" bannerName="cart_multiple_products"
            elementInViewport
            [viewportMargin]="'0px'"
            [viewportThreshold]="0"
            [viewportRoot]="null"
            (viewportVisibilityChange)="handleCompleteOrderBannerVisibility($event)"
            (goToCart)="goToCart()"
            [userDrImage]="userDrImage"
            [productsInCart]="productsInCart"
            [toolbarIcons]="toolbarIcons"
            [cartDiscount]="cartDiscount"
            [totalSp]="totalSP"
            [cartScriptBannerHeaderExperiment]="cartScriptBannerHeaderExperiment"
          >
          </app-complete-your-multiple-order>
        </ng-container>
        <ng-container *ngIf="productsInCart.length === 1 && userStatus.PAID && !voiceNoteByScript && !showSuggestedForYouBanner">
          <complete-your-order
            appTrackable pageName="homePage" bannerName="cart_single_product"
            elementInViewport
            [viewportMargin]="'0px'"
            [viewportThreshold]="0"
            [viewportRoot]="null"
            (viewportVisibilityChange)="handleCompleteOrderBannerVisibility($event)"
            (goToCart)="goToCart()"
            [productsInCart]="productsInCart"
            [cartDiscount]="cartDiscount"
            [totalSp]="totalSP"
            [userDrImage]="userDrImage"
            [cartScriptBannerHeaderExperiment]="cartScriptBannerHeaderExperiment"
          >
          </complete-your-order>
        </ng-container>
        <ng-container *ngIf="showSuggestedForYouBanner && userStatus.PAID && !voiceNoteByScript">
          <suggested-for-you appTrackable pageName="homePage" bannerName="cart_single_product" (goToCart)="addProductToCart($event)" [recommendedItems]="recommendedItems" [productsInCart]="productsInCart" [cartDiscount]="cartDiscount" [totalSp]="totalSP"></suggested-for-you>
        </ng-container>
      </div>
      <!--slider-->
      <swiper id="main-swiper" class="home-page-swiper tw-max-w-full" [ngClass]="{'tw-overflow-visible': isMainSwiperMounted, 'tw-mb-5': swiperCardsBannerMain?.swiperRef?.slides?.length}" #swiperCardsBannerMain [config]="carouselConfig" (afterInit)="onAfterInitOfMainSwiper()">
        <!-- voice note banner-->
        <ng-container *ngFor="let regimen of regimens; let i = index">
          <ng-container *ngIf="!regimen.isPreparationTimePending && !regimen.active && !regimen.orderPlaced && regimen.class !== appConfig.Shared.Regimen.Class.BODY">
            <div *swiperSlide class="tw-flex tw-flex-col tw-gap-4">
              <div class="card tw-flex tw-flex-col tw-items-center tw-mx-4 tw-bg-white tw-rounded-[15px]" [ngClass]="{'tw-h-auto': !resetKitReadyBannerHeight, 'tw-h-0': resetKitReadyBannerHeight}">
                <regimen-kit-ready appTrackable pageName="homePage" [bannerName]="'regimen_kit_ready_' + regimen.class" [carousel]="true" [class]="regimen.class" [coverImage]="regimen?.regimenCoverImage" [user]="this.user" [userName]="this.userName" [regimen]="regimen" [doctorImage]="userDrImage" [showMoneyBackGuaranteeBanner]="shouldShowMoneyBackGuaranteeStripForRegimen(regimen)" [showDoubleCta]="showRegimenReadyDualCta" [isAcqCopyChangesExpActive]="isAcqCopyChangesExpActive"></regimen-kit-ready>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <!-- re-acquisition banners-->
        <!--want to take dr checkup-->
        <ng-container *ngIf="reAcquisitionBannerType == 'reAcquisitionBannerReady'" class="tw-mt-4 tw-mb-2">
          @if (isReAcquistionRebrandingExpEnabled) {
            <doctor-checkup-reminder-banner appTrackable bannerName="reacquisition_start_checkup_banner" [carousel]="true" *swiperSlide [doctorDetails]="doctorDetails" [cssClasses]="'tw-mt-4 tw-mb-2'" (actionClick)="navigateToReAcquisitionFlow('reAcquisitionBannerReady')">
              <span i18n="@@restartYourRoutine">Hi <span class="tw-capitalize">{{ user?.get('PatientName') }}</span>, restart your routine with a free doctor checkup</span>
            </doctor-checkup-reminder-banner>
          } @else {
            <want-dr-checkup *swiperSlide (openReAcquisitionPage)="openReAcquisitionPage()"></want-dr-checkup>
          }
        </ng-container>

        @if (reAcquisitionBannerType === 'reAcquisitionCheckupPending') {
          <incomplete-banner appTrackable bannerName="reacquisition_checkup_incomplete" [carousel]="true" *swiperSlide [userFirstName]="userFirstName" (click)="navigateToReAcquisitionFlow('reAcquisitionCheckupPending')"></incomplete-banner>
        }
        <!-- waiting for doctor call-->
        <ng-container *ngIf="reAcquisitionBannerType === 'waitingForReAcquisitionCall'">
          @if (isReAcquistionRebrandingExpEnabled) {
            <processing-banner *swiperSlide appTrackable pageName="homePage" bannerName="reacquisition_checkup_scheduled" [carousel]="true">
              <h1 slot="header" class="tw-text-400 tw-mb-[17px] tw-text-gray-800 tw-w-[70%]">
                <ng-container [ngSwitch]="timeService.getDoctorCallTiming()">
                  <span *ngSwitchCase="'working'" i18n="@@doctorCallWithin2To3Hours">Your doctor will call you within 2-3 hours</span>
                  <span *ngSwitchCase="'evening'" i18n="@@doctorCallTomorrow">Your doctor will call you tomorrow</span>
                  <span *ngSwitchCase="'early'" i18n="@@doctorCallAfter8AMToday">Your doctor will call you after 8 AM today</span>
                </ng-container>
              </h1>
              <p slot="sub-header" class="tw-text-gray-800 tw-font-bold tw-text-200 tw-w-[32%] tw-leading-[15px]" i18n="@@yourCheckupIsInProcess">Your checkup is in progress</p>
              <img slot="doctor-image" src="https://cdn.cureskin.com/app/img/dr_charu_single.png" alt="Doctor" class="tw-w-[125px] tw-object-cover tw-shadow-lg"/>
            </processing-banner>
          } @else {
            <doctor-call *swiperSlide></doctor-call>
          }
        </ng-container>
        <!-- missed doctor call-->
        <ng-container *ngIf="reAcquisitionBannerType === 'missedReAcquisitionCall'">
          <missed-doctor-call appTrackable bannerName="reacquisition_call_RNR" [carousel]="true" [isReAcquistionRebrandingExpEnabled]="isReAcquistionRebrandingExpEnabled" [userFirstName]="userFirstName" *swiperSlide (openReAcquisitionPage)="openReAcquisitionPage()"></missed-doctor-call>
        </ng-container>
        <!-- FOLLOWUP BANNERS along with Level 2 banners-->
        <!-- Follow up report created-->
        <ng-container *ngIf="followUpReport">
          <ng-container>
            <report-is-ready appTrackable pageName="homePage" bannerName="report_created" [carousel]="true" *swiperSlide (openFollowUpReport)="openFollowUpReport()"></report-is-ready>
          </ng-container>
        </ng-container>
        <!-- Checkup is scheduled on next two days-->
        <ng-container *ngIf="selectedFollowUpBanner === 'followUpScheduledInTwoDays'">
          <ng-container *ngIf="selfCheckupWindowDetermined">
            <ng-container *ngIf="isWithinSelfCheckupWindow">
              <app-self-checkup-banner [shouldShowUpdatedUI]="shouldShowChangedSelfCheckupUi" [followUp]="followUp()" [daysSinceLastDelivery]="selfCheckupDaysSinceLastDelivery" appTrackable pageName="homePage" bannerName="self_checkup_photo" [carousel]="true" *swiperSlide [user]="user" [instantCheckups]="instantCheckups"></app-self-checkup-banner>
            </ng-container>
            <ng-container *ngIf="!isWithinSelfCheckupWindow">
              <doctor-checkup-reminder-banner appTrackable pageName="homePage" [bannerName]="'checkup_due'" [carousel]="true" *swiperSlide [doctorDetails]="doctorDetails" (actionClick)="handleCheckupBannerClick()">
                <span i18n="@@hiYourDoctorCheckupIsDueToday">Hi <span class="tw-capitalize">{{ user?.get('PatientName') }}</span>, Your doctor checkup is due today</span>
              </doctor-checkup-reminder-banner>
            </ng-container>
          </ng-container>
        </ng-container>
        <!-- anytime followUpEnabled-->
        <ng-container *ngIf="selectedFollowUpBanner === 'anyTimeFollowUpEnabled'">
          <ng-container *ngIf="selfCheckupWindowDetermined">
            <ng-container *ngIf="isWithinSelfCheckupWindow">
              <app-self-checkup-banner [shouldShowUpdatedUI]="shouldShowChangedSelfCheckupUi" [followUp]="followUp()" [daysSinceLastDelivery]="selfCheckupDaysSinceLastDelivery" *swiperSlide [user]="user" [instantCheckups]="instantCheckups"></app-self-checkup-banner>
            </ng-container>
            <ng-container *ngIf="!isWithinSelfCheckupWindow">
              <doctor-checkup-reminder-banner appTrackable pageName="homePage" [bannerName]="'checkup_due'" [carousel]="true" *swiperSlide [doctorDetails]="doctorDetails" (actionClick)="handleCheckupBannerClick()">
                <span i18n="@@hiYourDoctorCheckupIsDueToday">Hi <span class="tw-capitalize">{{ user?.get('PatientName') }}</span>, Your doctor checkup is due today</span>
              </doctor-checkup-reminder-banner>
            </ng-container>
          </ng-container>
        </ng-container>
        <!-- followUp waitingForImage-->
        <ng-container *ngIf="selectedFollowUpBanner === 'followUpWaitingForImage'">
          <ng-container>
            <requesting-photo appTrackable pageName="homePage" bannerName="blur_photo" [carousel]="true" *swiperSlide (startFollowUp)="startFollowUp('WAITING_FOR_IMAGE_BANNER_CLICKED')"></requesting-photo>
          </ng-container>
        </ng-container>
        <!-- followUp is ready waiting for report creation-->
        <ng-container *ngIf="selectedFollowUpBanner === 'followUpReadyWaitingForReport' && !festivalDelayBannerEnabled">
          <ng-container>
            <report-getting-ready appTrackable pageName="homePage" bannerName="creating_report" [carousel]="true" *swiperSlide></report-getting-ready>
          </ng-container>
        </ng-container>
        <!-- last followUp is skipped-->
        <ng-container *ngIf="selectedFollowUpBanner === 'lastFollowUpSkipped'">
          <ng-container *ngIf="selfCheckupWindowDetermined">
            <ng-container *ngIf="isWithinSelfCheckupWindow">
              <app-self-checkup-banner [shouldShowUpdatedUI]="shouldShowChangedSelfCheckupUi" [followUp]="followUp()" [daysSinceLastDelivery]="selfCheckupDaysSinceLastDelivery" *swiperSlide [user]="user" [instantCheckups]="instantCheckups"></app-self-checkup-banner>
            </ng-container>
            <ng-container *ngIf="!isWithinSelfCheckupWindow">
              <doctor-checkup-reminder-banner appTrackable pageName="homePage" [bannerName]="'checkup_due'" [carousel]="true" *swiperSlide [doctorDetails]="doctorDetails" (actionClick)="handleCheckupBannerClick()">
                <span i18n="@@hiYourDoctorCheckupIsDueToday">Hi <span class="tw-capitalize">{{ user?.get('PatientName') }}</span>, Your doctor checkup is due today</span>
              </doctor-checkup-reminder-banner>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="notListenedVoiceMessage && showVoiceNoteBanner && user?.get('allocatedDoctor')">
          <app-voice-note-banner
            appTrackable pageName="homePage"
            bannerName="voice_note"
            [carousel]="true"
            *swiperSlide
            [docImg]="voiceNoteBannerDetails.doctorDisplayImageURL || defaultDoctorImage"
            [voiceUrl]="voiceNoteBannerDetails.voiceUrl"
            [trackEventAudio]="voiceNoteBannerDetails.trackEventAudio"
            [message]="voiceNoteBannerDetails.message"
            [doctorName]="voiceNoteBannerDetails?.doctorName"
            [kitImageUrl]="voiceNoteBannerDetails?.regimenCoverImageUrl"
            [isDoctorVerifiedKit]="isDoctorVerifiedKit"
            [regimen]="regimen"
            [orderChatId]="notListenedVoiceMessage?.id"
            (trackVoiceEvent)="trackVoiceEvent(swiperCardsBannerMain,$event)"
            (languageChanged)="refreshVoiceNote()"
          ></app-voice-note-banner>
        </ng-container>
        <!--Unpaid state-->
        <!--Incomplete chat-->
        <ng-container *ngIf="consultationSession">
          <ng-container *ngIf="concernClass">
            <ng-container *ngIf="isFaceChatPending">
              <div appTrackable pageName="homePage" bannerName='incomplete_chat_face' [carousel]="true" *swiperSlide id="face" #face
                   class="tw-gap-4 tw-rounded-2xl tw-mx-4 tw-shadow-z1 tw-relative tw-bg-white tw-bg-grid-fade-rtl tw-bg-contain tw-bg-right-bottom tw-bg-no-repeat"
                   (click)="openChatFromNewIncompleteChatBanner($event)">
                <div
                  class="tw-flex tw-gap-2 tw-justify-start tw-items-center tw-bg-teal-100 tw-rounded-tl-4 tw-rounded-tr-4 tw-py-3 tw-px-4">
                  <span class="tw-w-2 tw-h-2 tw-bg-red-400 tw-rounded-full"></span>
                  @if (isRegimenExpired) {
                    <h1 class="tw-text-teal-600 tw-font-medium tw-text-200" i18n="@@completeSkinChatToRestartTreatment">Complete skin chat to restart treatment</h1>
                  } @else {
                    <h1 class="tw-text-teal-600 tw-font-medium tw-text-200" i18n="@@yourSkinTreatment">Your Skin Treatment</h1>
                  }
                </div>
                <div class="tw-py-5 tw-px-5">
                  <div class="tw-text-300">
                    <div class="tw-flex tw-justify-start tw-items-center tw-mb-[1px]" [ngClass]="{'tw-gap-1': [appConfig.Shared.Languages.ML, appConfig.Shared.Languages.KN, appConfig.Shared.Languages.TE, appConfig.Shared.Languages.TA].includes(user.get('languagePreference'))}">
                          <span class="tw-flex tw-flex-1 tw-items-center">
                            <p class="" i18n="@@name">Name</p>:
                          </span>
                      <p class="tw-flex-1 tw-capitalize">{{ userFirstName }}</p>
                    </div>
                    <div class="tw-flex tw-justify-start tw-items-center tw-mb-[1px]" [ngClass]="{'tw-gap-1': [appConfig.Shared.Languages.ML, appConfig.Shared.Languages.KN, appConfig.Shared.Languages.TE, appConfig.Shared.Languages.TA].includes(user.get('languagePreference'))}">
                          <span class="tw-flex tw-flex-1 tw-items-center">
                            <p class="" i18n="@@age">Age</p>:
                          </span>
                      <p class="tw-flex-1">{{ userAge }} yrs</p>
                    </div>
                    <div class="tw-flex tw-justify-start tw-items-center">
                        <span class="tw-flex tw-flex-1 tw-items-center">
                          <p [ngClass]="{'tw-leading-4 tw-max-w-28 tw-text-wrap' : user.get('languagePreference') === 'ta'}" i18n="@@selectedConcern">Selected Concern</p>:
                        </span>
                      <p class="tw-flex-1 tw-font-bold tw-text-orange-400 tw-h-4 tw-leading-none tw-flex tw-justify-start tw-items-start">{{ faceDisplayConcern }}</p>
                    </div>
                  </div>
                </div>
                <div class="tw-flex tw-justify-center tw-items-center tw-px-4 tw-pb-4">
                    <span i18n="@@continueChatFull"
                          class="tw-w-full tw-bg-teal-600 tw-text-white tw-py-2 tw-px-8 tw-rounded-xl tw-text-300 tw-flex tw-justify-center tw-items-center tw-font-bold shine-button tw-relative tw-overflow-hidden">
                      Continue chat
                    </span>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="isHairChatPending">
              <div appTrackable pageName="homePage" bannerName='incomplete_chat_hair' [carousel]="true" *swiperSlide id="hair" #hair
                   class="tw-gap-4 tw-rounded-2xl tw-mx-4 tw-shadow-z1 tw-relative tw-bg-white tw-bg-grid-fade-rtl tw-bg-contain tw-bg-right-bottom tw-bg-no-repeat"
                   (click)="openChatFromNewIncompleteChatBanner($event)">
                <div
                  class="tw-flex tw-gap-2 tw-justify-start tw-items-center tw-bg-teal-100 tw-rounded-tl-4 tw-rounded-tr-4 tw-py-3 tw-px-4">
                  <span class="tw-w-2 tw-h-2 tw-bg-red-400 tw-rounded-full"></span>
                  @if (isRegimenExpired) {
                    <h1 class="tw-text-teal-600 tw-font-medium tw-text-200" i18n="@@completeHairChatToRestartTreatment">Complete hair chat to restart treatment</h1>
                  } @else {
                    <h1 class="tw-text-teal-600 tw-font-medium tw-text-200" i18n="@@yourHairTreatment">Your Hair Treatment</h1>
                  }
                </div>
                <div class="tw-py-5 tw-px-5">
                  <div class="tw-text-300">
                    <div class="tw-flex tw-justify-start tw-items-center tw-mb-[1px]">
                          <span class="tw-flex tw-flex-1 tw-items-center">
                            <p class="" i18n="@@name">Name</p>:
                          </span>
                      <p class="tw-flex-1 tw-capitalize">{{ userFirstName }}</p>
                    </div>
                    <div class="tw-flex tw-justify-start tw-items-center tw-mb-[1px]">
                          <span class="tw-flex tw-flex-1 tw-items-center">
                            <p class="" i18n="@@age">Age</p>:
                          </span>
                      <p class="tw-flex-1">{{ userAge }} yrs</p>
                    </div>
                    <div class="tw-flex tw-justify-start tw-items-center">
                        <span class="tw-flex tw-flex-1 tw-items-center">
                          <p [ngClass]="{'tw-leading-4 tw-max-w-28 tw-text-wrap' : user.get('languagePreference') === 'ta'}" i18n="@@selectedConcern">Selected Concern</p>:
                        </span>
                      <p class="tw-flex-1 tw-font-bold tw-text-orange-400 tw-h-4 tw-flex tw-justify-start tw-items-start tw-leading-none">{{ hairDisplayConcern }}</p>
                    </div>
                  </div>
                </div>
                <div class="tw-flex tw-justify-center tw-items-center tw-px-4 tw-pb-4">
                    <span i18n="@@continueChatFull"
                          class="tw-w-full tw-bg-teal-600 tw-text-white tw-py-2 tw-px-8 tw-rounded-xl tw-text-300 tw-flex tw-justify-center tw-items-center tw-font-bold shine-button tw-relative tw-overflow-hidden">
                      Continue chat
                    </span>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
        <!--request for data-->
        <ng-container *ngIf="requestDataInTicket">
          <request-data appTrackable pageName="homePage" bannerName='request_data' [carousel]="true" *swiperSlide [userDoctor]="userDoctor" (viewTicket)="viewTicket()"></request-data>
        </ng-container>
        <!--festival banner-->
        <ng-container *ngIf="selectedFollowUpBanner === 'followUpReadyWaitingForReport' && festivalDelayBannerEnabled">
          <festive-banner appTrackable pageName="homePage" bannerName='festive' [carousel]="true" *swiperSlide></festive-banner>
        </ng-container>
        <div class="cardHolder flex flex-row tw-gap-2" *ngIf="userStatus.PAID">
          <div class="card w50 tw-px-4 tw-py-2 bdr-rad-10" (click)="trackEventAndNavigateTo('HOME_INSTRUCTIONS', '/user?tab=regimen')">
            <img class="w30 rounded" src="https://cdn.cureskin.com/app/img/instruction.gif" />
            <div class="tw-flex tw-justify-between tw-items-center mT10">
              <div class="text face" i18n="@@instructions">Instructions</div>
              <cs-icon class="tw-h-4 tw-w-4" [iconName]='"chevron_right"'></cs-icon>
            </div>
          </div>
          <div class="card w50 tw-px-4 tw-py-2 bdr-rad-10" (click)="trackEventAndNavigateTo('HOME_NEED_CHECKUP', '/user/checkup')" [ngClass]='{ "notify notify-new": tabUpdates.FOLLOWUP }'>
            <img class="w30 rounded" src="https://cdn.cureskin.com/app/img/checkup.gif" />
            <div class="tw-flex tw-justify-between tw-items-center mT10">
              <div class="text hair" i18n="@@checkupsNew">Checkups</div>
              <cs-icon class="tw-h-4 tw-w-4" [iconName]='"chevron_right"'></cs-icon>
            </div>
          </div>
        </div>
      </swiper>
      @if(showRegimenReorderBanner && regimenReorderKitDetails?.length) {
        @if(regimenReorderKitDetails?.length === 1) {
          <div class="tw-mb-4">
            <regimen-reorder-banner [bannerDetail]="regimenReorderKitDetails[0]" [orderState]="user?.get('orderState')"></regimen-reorder-banner>
          </div>
        } @else {
          <div class="tw-relative tw-mb-5">
            <swiper id="reorder-swiper" class="home-page-swiper tw-max-w-full" [config]="reorderCarouselConfig">
              <ng-container *ngFor="let regimenReorderKitDetail of regimenReorderKitDetails">
                <div *swiperSlide>
                  <regimen-reorder-banner [bannerDetail]="regimenReorderKitDetail" [orderState]="user?.get('orderState')"></regimen-reorder-banner>
                </div>
              </ng-container>
            </swiper>
            <div id="reorder-swiper-pagination"></div>
          </div>
        }
      }
      <app-money-back-guarantee-banner *ngIf="moneyBackGuaranteeMainBannerRegimen" [regimen]="moneyBackGuaranteeMainBannerRegimen"></app-money-back-guarantee-banner>
      <!-- Regimen going to expire banner-->
      <regimen-expiry-banner appTrackable bannerName="regimen_will_expire" [eventData]="regimenExpiryEventData" *ngIf="regimenExpiryExperiment && regimenExpiryBannerData?.showBanner" [regimenExpiryBannerData]="regimenExpiryBannerData" (buttonClick)="handleRegimenExpiryBannerClick()">
        <p slot="header" class="tw-font-bold tw-text-500 tw-leading-[22px] tw-font-lexend tw-text-black tw-text-center">
          @if (regimenExpiryBannerData?.regimenExpireIn === 0) {
            <span i18n="@@yourDoctorCheckupsWillBeBlockedToday"><span class="tw-capitalize">{{this.userFirstName}}</span>, your doctor check-ups <br /> will be blocked today!</span>
          } @else if (regimenExpiryBannerData?.regimenExpireIn === 1) {
            <span i18n="@@yourDoctorCheckupsWillBeBlockedTomorrow"><span class="tw-capitalize">{{this.userFirstName}}</span>, your doctor check-ups <br /> will be blocked tomorrow!</span>
          } @else if (regimenExpiryBannerData?.regimenExpireIn > 1 && regimenExpiryBannerData?.regimenExpireIn <= 10) {
            <span i18n="@@yourDoctorCheckupsWillBeBlockedInDays"><span class="tw-capitalize">{{this.userFirstName}}</span>, your doctor check-ups <br /> will be blocked in {{regimenExpiryBannerData?.regimenExpireIn}} days!</span>
          } @else {
            <span i18n="@@yourDoctorCheckupsWillBeBlockedSoon"><span class="tw-capitalize">{{this.userFirstName}}</span>, your doctor check-ups <br /> will be blocked soon!</span>
          }
        </p>
        <p slot="sub-header" class="tw-font-body tw-font-normal tw-text-200 tw-leading-[17px] tw-text-gray-800 tw-text-center tw-mt-1" i18n="@@notFollowingYourTreatment"> Since we noticed you are not following your <br /> entire treatment as prescribed </p>
        <div slot="button" class="tw-w-max tw-m-auto tw-mt-4 tw-bg-teal-600 tw-rounded-2 tw-text-400 tw-text-white tw-font-bold tw-font-body tw-px-8 tw-py-[10px] tw-text-nowrap tw-align-baseline">
          @if (regimenExpiryBannerData?.redirectToFollowUp) {
            <span i18n="@@takeCheck-upNow">Take Check-up Now</span>
          } @else {
            <span i18n="@@unlockMoreCheckupUps">Unlock More Checkup-ups </span>
          }
        </div>
      </regimen-expiry-banner>
      <!-- Regimen expired banner-->
      @if (showRegimenExpiredBanner) {
        <regimen-expired-banner appTrackable pageName="homePage" bannerName="regimen_expired_banner" [regimenExpiredBannerData]="regimenExpiredBannerData" (hideBanner)="hideRegimenExpiredBanner()"></regimen-expired-banner>
      }
      <!-- Recently Viewed Products -->
      <recently-viewed-products
        appTrackable
        pageName="homePage"
        bannerName="recently_viewed_products"
        *ngIf="shouldShowRecentlyViewedSection"
        [location]="recentlyViewedLocation.HOME"
        [recentlyViewedData]="recentlyViewedData"
        [cartData]="getCartDataForRecentlyViewed()">
      </recently-viewed-products>
      <!-- Gamification Banner Position: 4days (Below recently viewed, Above cross-sell) -->
      <ng-container *ngIf="shouldShowMainGamificationBannerAtPosition('4days')">
        <app-gamification-banner
          [todayProductUsageData]="todayProductUsageData"
          [user]="user"
          [regimen]="latestActiveRegimen"
          (scratchCardDismissedWithoutClaim)="onScratchCardDismissedWithoutClaim()"
          (rewardClaimed)="onRewardClaimed($event)">
        </app-gamification-banner>
      </ng-container>
      <ng-container *ngIf="reAcquisitionBannerType === 'missedReAcquisitionCall'">
        <missed-doctor-call appTrackable bannerName="reacquisition_call_RNR" [carousel]="true" *swiperSlide [isReAcquistionRebrandingExpEnabled]="isReAcquistionRebrandingExpEnabled" [userFirstName]="userFirstName" (openReAcquisitionPage)="openReAcquisitionPage()"></missed-doctor-call>
      </ng-container>
      <div class="tw-mb-2" *ngIf="swiperCardsBannerMain?.swiperRef?.slides?.length"></div>
      <!--      nutra push banner -->
      <div appTrackable pageName="homePage" [bannerName]="'nutra_push'" [eventData]="{type: nutraPushBottomSheetData?.objectId}" *ngIf="nutraPushBannerData && nutraPushBottomSheetData?.objectId && regimensClass" class="tw-mb-6">
        <nutra-push-banner [nutraPushBannerData]="nutraPushBannerData" [nutraPushExperimentVariantData]="nutraPushExperimentVariantData" [nutraPushBottomSheetData]="nutraPushBottomSheetData" [cartItems]="cartItems" [regimensClass]="regimensClass"></nutra-push-banner>
      </div>
      <app-regimen-offer-product-banner *ngIf="isRegimenExtraProductBannerVisible" (click)="regimenOfferProduct();" class="tw-mx-4 tw-mb-4 tw-box-border">
        <app-regimen-offer-tag><span i18n="@@limitedTimeOfferPouch">Limited time offer</span></app-regimen-offer-tag>
        <regimen-offer-product-title><span i18n="@@freePouch">+ Free Pouch</span></regimen-offer-product-title>
        <regimen-offer-product-caption><span i18n="@@withYourPurchase">with your treatment kit purchase</span></regimen-offer-product-caption>
      </app-regimen-offer-product-banner>
      <ng-container *ngIf="shouldShowTakePhotoBanner">
        <take-photo-banner appTrackable pageName="homePage" bannerName="take_photo" [channels]="PRIMARY_CHANNELS" *ngIf="takePhotoBannerTrigerringStates?.orderWaitingForImage" class="tw-mx-4 tw-mb-4 tw-box-border" (click)="handleTakePhotoBannerClick()" [userLanguage]="userLanguage">
          <take-photo-banner-title> <span i18n="@@takeLatestPhotoNow"> Take latest photo now </span> </take-photo-banner-title>
          <take-photo-banner-caption> <span i18n="@@asRequestedByYourDoctor"> as requested by your doctor </span> </take-photo-banner-caption>
        </take-photo-banner>
        <take-photo-banner appTrackable pageName="homePage" bannerName="take_photo" [channels]="PRIMARY_CHANNELS" *ngIf="takePhotoBannerTrigerringStates?.orderPlacedWithoutCheckup" class="tw-mx-4 tw-mb-4 tw-box-border" (click)="handleTakePhotoBannerClick()" [userLanguage]="userLanguage">
          <take-photo-banner-title> <span i18n="@@trackVisibleImprovement"> Track visible improvement </span> </take-photo-banner-title>
          <take-photo-banner-caption> <span i18n="@@byAddingPhotosEveryMonth"> by adding photos every month </span> </take-photo-banner-caption>
        </take-photo-banner>
        <take-photo-banner appTrackable pageName="homePage" bannerName="take_photo" [channels]="PRIMARY_CHANNELS" *ngIf="takePhotoBannerTrigerringStates?.firstRegimenWithoutCheckup" class="tw-mx-4 tw-mb-4 tw-box-border" (click)="handleTakePhotoBannerClick()" [userLanguage]="userLanguage">
          <take-photo-banner-title> <span i18n="@@trackVisibleImprovement"> Track visible improvement </span> </take-photo-banner-title>
          <take-photo-banner-caption> <span i18n="@@byAddingPhotosEveryMonth"> by adding photos every month </span> </take-photo-banner-caption>
        </take-photo-banner>
      </ng-container>
      <div *ngIf="feedback" class="tw-mb-4">
        <n-p-s-banner appTrackable pageName="homePage" bannerName='NPS_feedback' [feedback]="feedback"></n-p-s-banner>
      </div>
      <ng-container *ngIf="!consultationSession && this.crossSellRegimenExperiment?.enable && showNewCrossRegimenBanner">
        <cross-regimen-banner-v2
          appTrackable pageName="homePage"
          [bannerName]="latestActiveRegimen.class === appConfig.Shared.Regimen.Class.HAIR ? 'cross_sell_hair' : 'cross_sell_face'"
          [crossSellBannerExperiment]="crossSellRegimenExperiment"
          [latestActiveRegimen]="latestActiveRegimen"
          [user]="user"
        ></cross-regimen-banner-v2>
      </ng-container>
      <ng-container *ngIf="!this.crossSellRegimenExperiment?.enable && !showNewCrossRegimenBanner">
        <cross-regimen-banner appTrackable pageName="homePage" bannerName="cross_sell_regimen"></cross-regimen-banner>
      </ng-container>
      <!-- Gamification Banner Position: 5Days+ (Below cross-sell, Above weekly journey) -->
      <ng-container *ngIf="shouldShowMainGamificationBannerAtPosition('5Days+')">
        <app-gamification-banner
          [todayProductUsageData]="todayProductUsageData"
          [user]="user"
          [regimen]="latestActiveRegimen"
          (scratchCardDismissedWithoutClaim)="onScratchCardDismissedWithoutClaim()"
          (rewardClaimed)="onRewardClaimed($event)">
        </app-gamification-banner>
      </ng-container>
      <ng-container *ngIf="!userStatus.PAID && unpaidUserChatBotExperiment">
        <div class="tw-bg-white tw-px-4 tw-py-[17px]">
          <app-user-query-chat-banner [user]="user" [showHeader]="false" [regimen]="latestUnBoughtRegimen" [homePageView]="true"></app-user-query-chat-banner>
        </div>
      </ng-container>
      <!--take photo banner-->
      <ng-container *ngIf="!takePhotoBannerPositionBottom">
        <app-analysis-banner appTrackable pageName="homePage" bannerName='instant_checkup' [channels]="PRIMARY_CHANNELS" (analysisOfTheDay)="analysisOfTheDay()"></app-analysis-banner>
      </ng-container>
      <div class="tw-mb-4" *ngIf="!userStatus.PAID">
        <testimonials-widget [concernClass]="concernClass || regimenKit" [language]='user?.get("languagePreference") || appConfig.Shared.Languages.EN' [gender]='user.get("Gender") || appConfig.Shared.Gender.FEMALE' [decreaseHeaderGap]="!unpaidUserChatBotExperiment" (redirectToTestimonialPage)="redirectToTestimonialsPage()"></testimonials-widget>
      </div>
      @if (showExploreSliderBanner) {
        <app-explore-slider-banner></app-explore-slider-banner>
      }
      <section class="banners" *ngIf="showClaimCashBanner" (click)='navigateTo("/user/wallet")'>
        <img [src]='imageService.getURL("https://cdn.cureskin.com/app/img/claim-cash.png")' />
      </section>
      <section class="notification" id="notification" *ngIf="notification.message" (click)="navigateTo(notification.link)">
        <div class="holder">
          <div class="icon">
            <em class="cs-icon-discount" *ngIf='notification.type === "OFFER"' [ngClass]="{ 'spin': isTabActive }"></em>
            <em class="cs-icon-notification" *ngIf='!notification.type || notification.type !== "OFFER"' [ngClass]="{ 'ring': isTabActive }"></em>
          </div>
          <div class="content">
            <span [innerHTML]="notification.message"></span>
          </div>
        </div>
      </section>
      <ng-container *ngIf="homePageRehaulExperiment && showTreatmentPhilosophyWidget">
        <app-treatment-philosophy-widget appTrackable pageName="homePage" bannerName='treatment_philosophy_widget' [user]="user"></app-treatment-philosophy-widget>
      </ng-container>
      <!-- week 0 to 1-->
      <!-- Old Week 0 -->
      <div class="tw-relative tw-mb-4 weeklyCard tw-bg-teal-100" *ngIf="(isJourneyCardOne && !weeklyJourneyV2Experiment)">
        <app-week-zero-journey
          appTrackable
          pageName="homePage"
          bannerName='week_zero_journey'
          [channels]="PRIMARY_CHANNELS"
          [user]="user"
          [latestPlacedRegimenOrder]="latestPlacedRegimenOrder"
          [userDrImage]="userDrImage"
          [allocatedDoctor]="allocatedDoctor"
          [defaultDoctorImage]="defaultDoctorImage"
          [primaryConcern]="primaryConcern"
          [otherConcerns]="otherConcerns"
          (trackOrder)="trackOrder($event)"
          (openInstructions)="openInstructions($event)"
          (openDiet)="openDiet()"
          (openHelp)="openHelp($event)"
          (sendClickEvent)="sendClickEventFromOldWeeklyJourney($event)"
        >
        </app-week-zero-journey>
      </div>
      <!-- New Week 0 -->
      <ng-container *ngIf="((isJourneyCardOne && weeklyJourneyV2Experiment) && (!weeklyJourneyVariant?.weekVisibility || isWeekVisible(WeeklyJourneyType.WEEK_ZERO)))">
        <app-weekly-journey
          appTrackable
          pageName="homePage"
          bannerName='week_zero_journey'
          [channels]="PRIMARY_CHANNELS"
          [journeyType]="WeeklyJourneyType.WEEK_ZERO"
          [journeyData]="getWeeklyJourneyData(WeeklyJourneyType.WEEK_ZERO)"
        ></app-weekly-journey>
      </ng-container>
      <!-- Old Week 1 part 1 -->
      <div class="tw-relative tw-mb-4 weeklyCard tw-bg-teal-100" *ngIf="(isWeekOne && userStatus.PAID && !weeklyJourneyV2Experiment)">
        <app-week1-part-one
          appTrackable
          pageName="homePage"
          bannerName='week_one_part_1_journey'
          [channels]="PRIMARY_CHANNELS"
          [user]="user"
          [pendingCheckInCall]="pendingCheckInCall"
          [faceRegimenOrderDelivered]="faceRegimenOrderDelivered"
          [latestFaceRegimenDelivered]="latestFaceRegimenDelivered"
          (openInstructions)="openInstructions($event)"
          (openStaticArticle)='openStaticArticle("68tmQuvkpb",$event)'
          (openHelp)="openHelp($event)"
          (openCheckup)="openCheckup($event)"
          (sendClickEvent)="sendClickEventFromOldWeeklyJourney($event)"
        >

        </app-week1-part-one>
      </div>
      <!-- New Week 1 part 1 -->
      <ng-container *ngIf="((isWeekOne && userStatus.PAID && weeklyJourneyV2Experiment) && (!weeklyJourneyVariant?.weekVisibility || isWeekVisible(WeeklyJourneyType.WEEK_ONE_PART_ONE)))">
        <app-weekly-journey
          appTrackable
          pageName="homePage"
          bannerName='week_one_part_1_journey'
          [channels]="PRIMARY_CHANNELS"
          [journeyType]="WeeklyJourneyType.WEEK_ONE_PART_ONE"
          [journeyData]="getWeeklyJourneyData(WeeklyJourneyType.WEEK_ONE_PART_ONE)"
          (openStaticArticle)='openStaticArticle("68tmQuvkpb",$event)'
        ></app-weekly-journey>
      </ng-container>
      <!-- Old Week 1 part 2 -->
      <div class="tw-relative tw-mb-4 weeklyCard tw-bg-teal-100" *ngIf="(isJourneyCardTwo && userStatus.PAID && !weeklyJourneyV2Experiment)">
        <app-week1-part-two
          appTrackable
          pageName="homePage"
          bannerName='week_one_part_2_journey'
          [channels]="PRIMARY_CHANNELS"
          [user]="user"
          [pendingCheckInCall]="pendingCheckInCall"
          (openInstructions)="openInstructions($event)"
          (openStaticArticle1)='openStaticArticle("7T2BaIQHxh",$event)'
          (openStaticArticle2)='openStaticArticle("6dH4XFVff4",$event)'
          (sendClickEvent)="sendClickEventFromOldWeeklyJourney($event)"
        ></app-week1-part-two>
      </div>
      <!-- New Week 1 part 2 -->
      <ng-container *ngIf="((isJourneyCardTwo && userStatus.PAID && weeklyJourneyV2Experiment) && (!weeklyJourneyVariant?.weekVisibility || isWeekVisible(WeeklyJourneyType.WEEK_ONE_PART_TWO)))">
        <app-weekly-journey
          appTrackable
          pageName="homePage"
          bannerName='week_one_part_2_journey'
          [channels]="PRIMARY_CHANNELS"
          [journeyType]="WeeklyJourneyType.WEEK_ONE_PART_TWO"
          [journeyData]="getWeeklyJourneyData(WeeklyJourneyType.WEEK_ONE_PART_TWO)"
        ></app-weekly-journey>
      </ng-container>

      <!-- week 2 -->
      <!-- Old Week 2 part 1 -->
      <div class="tw-relative tw-mb-4 weeklyCard tw-bg-teal-100" *ngIf="(isJourneyCardThree && userStatus.PAID && !weeklyJourneyV2Experiment)">
        <app-week2-part-two
          appTrackable
          pageName="homePage"
          bannerName='week_two_part_1_journey'
          [channels]="PRIMARY_CHANNELS"
          [user]="user"
          [followUp]="followUp()"
          [userDrImage]="userDrImage"
          [defaultDoctorImage]="defaultDoctorImage"
          (openStaticArticle1)='openStaticArticle("BoXTnEmmEr",$event)'
          (openStaticArticle2)='openStaticArticle("68tmQuvkpb",$event)'
          (openCheckup)="openCheckup($event)"
          (sendClickEvent)="sendClickEventFromOldWeeklyJourney($event)"
        ></app-week2-part-two>
      </div>
      <!-- New Week 2 part 1 -->
      <ng-container *ngIf="((isJourneyCardThree && userStatus.PAID && weeklyJourneyV2Experiment) && (!weeklyJourneyVariant?.weekVisibility || isWeekVisible(WeeklyJourneyType.WEEK_TWO_PART_ONE)))">
        <app-weekly-journey
          appTrackable
          pageName="homePage"
          bannerName='week_two_part_1_journey'
          [channels]="PRIMARY_CHANNELS"
          [journeyType]="WeeklyJourneyType.WEEK_TWO_PART_ONE"
          [journeyData]="getWeeklyJourneyData(WeeklyJourneyType.WEEK_TWO_PART_ONE)"
        ></app-weekly-journey>
      </ng-container>

      <!-- Old Week 2 part 2 -->
      <div class="tw-relative tw-mb-4 weeklyCard tw-bg-teal-100" *ngIf="(isJourneyCardFour && userStatus.PAID && !weeklyJourneyV2Experiment)">
        <app-week2-part-one
          appTrackable
          pageName="homePage"
          bannerName='week_two_part_2_journey'
          [channels]="PRIMARY_CHANNELS"
          [user]="user"
          [followUp]="followUp()"
          (openInstructions)="openInstructions($event)"
          (openStaticArticle1)='openStaticArticle("hUUviTYk22",$event)'
          (openStaticArticle2)='openStaticArticle("7T2BaIQHxh",$event)'
          (sendClickEvent)="sendClickEventFromOldWeeklyJourney($event)"
        >

        </app-week2-part-one>
      </div>
      <!-- New Week 2 part 2 -->
      <ng-container *ngIf="((isJourneyCardFour && userStatus.PAID && weeklyJourneyV2Experiment) && (!weeklyJourneyVariant?.weekVisibility || isWeekVisible(WeeklyJourneyType.WEEK_TWO_PART_TWO)))">
        <app-weekly-journey
          appTrackable
          pageName="homePage"
          bannerName='week_two_part_2_journey'
          [channels]="PRIMARY_CHANNELS"
          [journeyType]="WeeklyJourneyType.WEEK_TWO_PART_TWO"
          [journeyData]="getWeeklyJourneyData(WeeklyJourneyType.WEEK_TWO_PART_TWO)"
        ></app-weekly-journey>
      </ng-container>

      <!-- week 3 -->
      <!-- Old Week 3 -->
      <div class="tw-relative tw-mb-4 weeklyCard tw-bg-teal-100" *ngIf="(isWeekThreeJourneyCard && userStatus.PAID && !weeklyJourneyV2Experiment)">
        <app-week3-part-one
          appTrackable
          pageName="homePage"
          bannerName='week_three_journey'
          [channels]="PRIMARY_CHANNELS"
          [user]="user"
          [followUp]="followUp()"
          (sendClickEvent)="sendClickEventFromOldWeeklyJourney($event)"
        ></app-week3-part-one>
      </div>
      <!-- New Week 3 -->
      <ng-container *ngIf="((isWeekThreeJourneyCard && userStatus.PAID && weeklyJourneyV2Experiment) && (!weeklyJourneyVariant?.weekVisibility || isWeekVisible(WeeklyJourneyType.WEEK_THREE)))">
        <app-weekly-journey
          appTrackable
          pageName="homePage"
          bannerName='week_three_journey'
          [channels]="PRIMARY_CHANNELS"
          [journeyType]="WeeklyJourneyType.WEEK_THREE"
          [journeyData]="getWeeklyJourneyData(WeeklyJourneyType.WEEK_THREE)"
        ></app-weekly-journey>
      </ng-container>

      <!-- week 4 -->
      <!-- Old Week 4 -->
      <div class="tw-relative tw-mb-4 weeklyCard tw-bg-teal-100" *ngIf="(isWeekFourJourneyCard && userStatus.PAID && !weeklyJourneyV2Experiment)">
        <app-week4-part-one
          appTrackable
          pageName="homePage"
          bannerName='week_four_journey'
          [channels]="PRIMARY_CHANNELS"
          [user]="user"
          [followUp]="followUp()"
          (sendClickEvent)="sendClickEventFromOldWeeklyJourney($event)"
        ></app-week4-part-one>
      </div>
      <!-- New Week 4 -->
      <ng-container *ngIf="((isWeekFourJourneyCard && userStatus.PAID && weeklyJourneyV2Experiment) && (!weeklyJourneyVariant?.weekVisibility || isWeekVisible(WeeklyJourneyType.WEEK_FOUR)))">
        <app-weekly-journey
          appTrackable
          pageName="homePage"
          bannerName='week_four_journey'
          [channels]="PRIMARY_CHANNELS"
          [journeyType]="WeeklyJourneyType.WEEK_FOUR"
          [journeyData]="getWeeklyJourneyData(WeeklyJourneyType.WEEK_FOUR)"
        ></app-weekly-journey>
      </ng-container>

      <!--redirect to new shop banner-->
      @if (shouldShowShopNavigateBanner) {
        <shop-navigate-banner appTrackable pageName="homePage" bannerName='shop_banner'></shop-navigate-banner>
      }

      <div id="nonStaticContent" [ngClass]="{
        'tw-mb-44': isDiscomfortBannerActive,
        'tw-mb-50': isDiscomfortVoiceNoteBannerActive,
        'tw-mb-28': !(isDiscomfortBannerActive && isDiscomfortVoiceNoteBannerActive)}" >
        <!--Analysis of the day-->
        <ng-container *ngIf="takePhotoBannerPositionBottom">
          <app-analysis-banner appTrackable pageName="homePage" bannerName='instant_checkup' [channels]="PRIMARY_CHANNELS" (analysisOfTheDay)="analysisOfTheDay()"></app-analysis-banner>
        </ng-container>
        <!--Diet plan-->
        <app-diet-plan appTrackable pageName="homePage" bannerName='diet_plan' *ngIf="!lastLevelBannerExperiment" [userStatus]="userStatus" (openDiet)="openDiet()"></app-diet-plan>
        <!--Refer and Earn banner-->
        <app-referral-banner appTrackable pageName="homePage" bannerName='referral' *ngIf="!lastLevelBannerExperiment" [userStatus]="userStatus" (referBannerClick)="referBannerClick()"></app-referral-banner>
        <!--New game-->
        <app-quiz-banner appTrackable pageName="homePage" bannerName='quiz' *ngIf="showOldQuizBanner" [userStatus]="userStatus" [showGameBanner]="showGameBanner" (openGame)="openGame()"></app-quiz-banner>
        <!-- Add this where you want the carousel to appear -->
        <div appTrackable pageName="homePage" [bannerName]="'last_levels'" *ngIf="lastLevelBannerExperiment && lastLevelBannerOrder?.length && userStatus.PAID" class="tw-pb-4 tw-px-4 tw-relative">
          <swiper [config]="customCarouselConfig" class="tw-w-full tw-rounded-xl tw-overflow-hidden">
            <!-- Render banners according to lastLevelBannerOrder -->
            <ng-container *ngFor="let bannerType of lastLevelBannerOrder">
              <!-- Diet banner -->
              <ng-container *ngIf="bannerType === 'DIET'">
                <div *swiperSlide class="tw-w-full" (click)="openDiet('lastLevelDietBanner')">
                  <last-level-banner type="DIET" [user]="user"></last-level-banner>
                </div>
              </ng-container>

              <!-- Refer banner -->
              <ng-container *ngIf="bannerType === 'REFER'">
                <div *swiperSlide class="tw-w-full" (click)="referBannerClick()">
                  <last-level-banner type="REFER" [user]="user"></last-level-banner>
                </div>
              </ng-container>

              <!-- Quiz banner -->
              <ng-container *ngIf="bannerType === 'QUIZ' && showGameBanner">
                <div *swiperSlide class="tw-w-full" (click)="openGame()">
                  <last-level-banner type="QUIZ" [user]="user"></last-level-banner>
                </div>
              </ng-container>
            </ng-container>
          </swiper>

          <!-- Custom pagination -->
          <div class="custom-pagination"></div>
        </div>
        <!--    notification banner   -->
        <notification-permission-banner
          appTrackable pageName="homePage" bannerName='enable_notfications'
          *ngIf="showNotificationBanner"
          (close)="respondPermissionBanner(false)"
          (enable)="respondPermissionBanner(true)">
        </notification-permission-banner>
        <div class="tw-bg-white tw-pt-5 tw-pb-1 tw-mb-4">
          <app-bento-grid appTrackable pageName="homePage" bannerName='bento_grid_bottom' [channels]="PRIMARY_CHANNELS" [columns]="2" [gap]="2" [padding]="4" ariaLabel="Treatment information and navigation">
            <ng-container *ngFor="let card of HomepageInfoCardsData[gridDisplayLanguage]; let i = index">
              <app-action-with-image-banner
                bentoGridItem
                [bentoGridItemSpan]="i === 0 ? 2 : 1"
                bentoGridItemAriaLabel="{{ card.bannerText }}"
                [imageUrl]="card.imageUrl"
                [bannerText]="card.bannerText"
                [bannerSubText]="card.bannerSubText"
                [navigationLink]="card.navigationLink">
              </app-action-with-image-banner>
            </ng-container>
          </app-bento-grid>
        </div>
        <!--FAQ section-->
        <app-faq-section></app-faq-section>
        <!--Contact us-->
        <app-explore-contact-banners [userStatus]="userStatus" [user]="user" [hideExplorePanel]="showExploreSliderBanner" (optedForSupport)="optedForSupport($event)" (exploreSectionRedirect)="exploreSectionRedirect()"></app-explore-contact-banners>
      </div>
    </div>
  </div>
</div>
<!--sticky bar for discomfort ticket-->
<discomfort-ticket *ngIf="!homePageFullScreenModeOn" [ngClass]="{'tw-hidden': isMenuOpen }" appTrackable pageName="homePage" [pendingTicket]="pendingDiscomfortTicket" [userName]="userName" [user]="user" [audioMessageInTicket]="audioMessageInTicket" [activeDiscomfortTicket]="activeDiscomfortTicket" [defaultDoctorImage]="defaultDoctorImage" [userDoctor]="allocatedDoctor" (trackVoiceEvent)="trackVoiceEventDiscomfortTicket($event)" [showDiscomfortBanner]="showDiscomfortBanner"></discomfort-ticket>

<!--sticky bar for cart items-->
<app-sticky-bar *ngIf="shouldShowStickyWidget && !audioMessageInTicket && !pendingDiscomfortTicket && !homePageFullScreenModeOn" [showStickyBars$]="showStickyBars$" [userStatus]="userStatus" [bannerContainer]="bannerContainer" [order]="order" [followUp]="followUp()" [defaultDoctorImage]="defaultDoctorImage" [toolbarIcons]="toolbarIcons" [user]="user" (onSlideChange)="onSlideChange($event)" (checkoutOrder)="checkoutOrder()" (onCancelClick)="onCancelClick()" (startFollowUp)="startFollowUp()" (kitUrl)="getKitImage()" (goToCartNav)="goToCartNav()"></app-sticky-bar>
<div class="navigation-drawer">
  <!-- <div class="drawer-bg" (click)="toggleMenu(false)" [ngClass]="{ 'open': isMenuOpen, 'close': !isMenuOpen, 'hide': isMenuOpen === undefined }"></div> -->
  <div class="drawer-content trans-x-hide" swipe="swipe" (coordinates)="swipeCoordinates($event)" [ngClass]='{ "slideFromLeft": isMenuOpen, "slideToLeft": isMenuOpen === false }' (click)="toggleMenu(false)">
    <div class="holder w100">
      <user-profile *ngIf="!loading" (onPopupToggle)="makeComponentActive(!$event)" [regimens]="regimens"></user-profile>
    </div>
  </div>
</div>
